export default __webpack_public_path__ + "static/media/blend-table-overlay.f1bc2d9d.svg";